import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores/Store';
import ViewProjectPage from './ViewProject';
import ViewProfessional from '../Professionals/viewProfessional';
import ViewUserPage from './ViewUser';
import { MenuItem } from '@mui/material';
import './style.scss';
import { OutlinedButton, TextInput, TextInputDropdown } from '../../../components';
const AtoZ = `${process.env.REACT_APP_CDN_URL}/globalAssets/A-ZFilter.svg`;
const ZtoA = `${process.env.REACT_APP_CDN_URL}/globalAssets/Z-AFilter.svg`;
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;

var mobile = require('is-mobile');

const Users = observer(() => {
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [ViewUser, setViewUser] = useState(false);
    const [ViewProject, setViewProject] = useState(false);
    const [UserMenu, setUserMenu] = useState(false);
    const [Users, setUsers] = useState([]);
    const [AddUser, setAddUser] = useState(false);
    const [SelectedUser, setSelectedUser] = useState('')
    const [Professionals, setProfessionals] = useState([]);
    const [Leads, setLeads] = useState([]);
    const [Briefs, setBriefs] = useState([]);
    const [Projects, setProjects] = useState([]);
    const [NewUser, setNewUser] = useState({
        firstName: '',
        lastName: '',
        email: '',
        roles: [],
        phone: '',
        permissions: [],
        date: new Date(),
    });
    const [NameFilter, setNameFilter] = useState('A-Z');
    const [DateFilter, setDateFilter] = useState('A-Z');
    const [RoleFilter, setRoleFilter] = useState('A-Z');
    const [searchTerm, setSearchTerm] = useState('');
    const EmailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const [Sortkey, setSorKey] = useState({
        Title: true,
        Department: false
    });

    useEffect(() => {
        getUsers();
    }, []);

    const getUsers = async () => {
        store.setLoading(true);
        try {
            let [Users, Briefs, projects, projectPlans, evaluation, quotes] = await Promise.all([
                store.getUsers(),
                store.getBriefs(),
                store.getProjects(),
                store.getProjectPlans(),
                store.getEvaluation(),
                store.getQuote()
            ]);

            if (Array.isArray(projects)) {
                projects = projects.filter(item => Object.keys(item).includes('projectPlan'))
            } else {
                projects = []
            };
            if (!Array.isArray(Users)) {
                Users = [];
            };
            if (!Array.isArray(quotes)) {
                quotes = [];
            };

            if (Array.isArray(evaluation) && evaluation.length > 0) {
                if (Array.isArray(projects) && projects.length > 0) {
                    projects = projects.filter(project => Object.keys(project).includes('evaluation') && (Object.keys(project).includes('brief') || Object.keys(project).includes('briefId')) && Object.keys(project).includes('client'));

                    for (let i = 0; i < projects.length; i++) {
                        let project = projects[i];
                        if (typeof project.evaluation === 'string') {
                            project.evaluation = evaluation.find(evaluation => evaluation._id === project.evaluation);
                        };
                        if (Object.keys(project).includes('brief')) {
                            project.brief = Briefs.find(brief => brief._id === project.brief);
                        } else if (Object.keys(project).includes('briefId')) {
                            project.brief = Briefs.find(brief => brief._id === project.briefId);
                        };
                        if (typeof project.client === 'string') {
                            project.client = Users.find(user => user._id === project.client);
                        };
                    };

                    projects = projects.filter(project => typeof project.evaluation === 'object' && typeof project.brief === 'object');
                } else {
                    projects = []
                }
            } else {
                evaluation = []
            };

            for (let i = 0; i < Users.length; i++) {
                let usser = Users[i];
                let userFullName = usser.firstName + ' ' + usser.lastName;
                usser.fullName = userFullName;
                if (Object.keys(usser).includes('roles') && Array.isArray(usser.roles)) {
                    for (let k = 0; k < usser.roles.length; k++) {
                        if (usser.roles[k] === 1987) {
                            usser['role'] = 'Admin';
                        };
                        if (usser.roles[k] === 1988) {
                            usser['role'] = 'Professional';
                        };
                        if (usser.roles[k] === 1989) {
                            usser['role'] = 'Client';
                        };
                    };
                };
            };

            const pros = Users.filter(item => item.roles[0] === 1988);
            const clients = Users.filter(item => item.roles[0] === 1989);
            const leads = Users.filter(item => item.roles[0] === 1987);

            let validBriefs = Briefs.filter(item => item.projectPlan && item.projectPlan.length > 0);
            let validProjects = projects.filter(item => item.projectPlan && Object.keys(item.projectPlan).length > 0);

            validBriefs.forEach(job => {
                const projectPlanId = job.projectPlan[0];
                const projectPlan = projectPlans.find(plan => plan._id === projectPlanId);
                const project = projects.find(project => project.brief._id === job._id);

                if (projectPlan) {
                    job.projectPlan[0] = projectPlan;
                }
                if (typeof project === 'object') {
                    job['evaluation'] = project.evaluation;
                    job['project'] = project;
                };
            });
            validProjects.forEach(project => {
                const projectPlanId = project.projectPlan[0];
                const projectPlan = projectPlans.find(plan => plan._id === projectPlanId);
                if (projectPlan) {
                    project.projectPlan = projectPlan;
                }
            });
            const professionals = pros.map(pro => {
                const userProjects = validProjects.filter((project) => {
                    if (Object.keys(project.projectPlan).includes('professional')) {
                        return project.projectPlan.professional === pro._id
                    } else { return false };
                });
                const userbriefs = validBriefs.filter((job) => {
                    if (Object.keys(job.projectPlan[0]).includes('professional')) {
                        return job.projectPlan[0].professional === pro._id
                    } else {
                        return false;
                    }
                });

                return {
                    ...pro,
                    projects: userProjects,
                    briefs: userbriefs
                };
            });
            validBriefs.forEach(job => {
                const professional = professionals.find(pro => pro._id === job.projectPlan[0].professional);
                const briefClient = clients.find(client => client._id === job.client);
                const briefLead = leads.find(lead => lead._id === job.talentPartner);
                if (typeof briefLead === 'object') {
                    job.talentPartner = briefLead;
                } else {
                    job.talentPartner = {
                        firstName: 'Not Assigned',
                        lastName: ''
                    }
                }
                if (typeof briefClient === 'object') {
                    job.client = briefClient;
                } else {
                    job.client = {
                        firstName: 'Not Assigned',
                        lastName: ''
                    }
                }
                if (typeof professional === 'object') {
                    job.projectPlan[0]['professional'] = professional;
                }
                if (Object.keys(job).includes('quote') && Array.isArray(job.quote) && job.quote.length > 0) {
                    if (typeof job.quote[0] === 'string') {
                        let quoteFromID = quotes.find(quote => quote._id === job.quote[0])
                        job.quote[0] = quoteFromID;
                    } else {
                        job.quote = [];
                    }
                } else {
                    job['quote'] = [];
                }
            });
            validProjects.forEach(project => {
                const professional = professionals.find(pro => pro._id === project.projectPlan.professional);
                const projectClient = clients.find(client => client._id === project.client);
                const projectLead = leads.find(lead => lead._id === project.fullfilmentLead);

                if (typeof projectLead === 'object') {
                    project.fulfillmentLead = projectLead;
                } else {
                    project.fulfillmentLead = {
                        firstName: 'Not Assigned',
                        lastName: ''
                    }
                }
                if (typeof projectClient === 'object') {
                    project.client = projectClient;
                } else {
                    project.client = {
                        firstName: 'Not Assigned',
                        lastName: ''
                    }
                }
                if (typeof professional === 'object') {
                    project.projectPlan['professional'] = professional;
                }
            });

            let updatedUsers = Users.map(user => {
                if (user.roles[0] === 1987) {
                    user.projects = validProjects.filter(project => project.fulfillmentLead && project.fulfillmentLead._id === user._id);
                    user.briefs = validBriefs.filter(brief => brief.talentPartner && brief.talentPartner._id === user._id);
                    return user;
                }
            });
            updatedUsers = updatedUsers.filter(item => item !== undefined);
            updatedUsers = updatedUsers.sort((a, b) => {
                const nameA = `${a.firstName || ''} ${a.lastName || ''}`.toLowerCase();
                const nameB = `${b.firstName || ''} ${b.lastName || ''}`.toLowerCase();
                return nameA.localeCompare(nameB);
            });
            setBriefs(validBriefs);
            setProjects(validProjects);
            setLeads(leads);
            setProfessionals(professionals);
            setUsers(updatedUsers);
            forceUpdate();
        } catch (error) {
            console.log(error);
        } finally {
            store.setLoading(false);
        }
    };
    const handleViewUser = (id) => {
        let users = Users;
        let selectedPro = users.find(user => user._id === id);
        setSelectedUser(selectedPro);
        setViewUser(true);
        forceUpdate();
    };
    const handleSaveUser = async () => {
        try {
            store.setLoading(true);
            let user = NewUser;
            let regexPass = EmailRegex.test(user.email);
            if (!regexPass) {
                store.setLoading(false);
                return;
            };
            let result = await store.createUser(user);
            if (!result) {
                alert('Error adding new user')
                store.setLoading(false);
                return;
            }
            setAddUser(false);
            alert('User added succesfully.');
            getUsers();
            forceUpdate()
        } catch (e) {
        } finally {
            store.setLoading(false);
        }

    };
    const handleUserDetailChange = (e) => {
        let user = NewUser;
        if (e.currentTarget.id === 'Name') {
            let fullName = e.target.value;
            user.firstName = fullName.split(' ')[0];
            user.lastName = fullName.split(' ')[1];
        }
        if (e.currentTarget.id === 'ContactNumber') {
            user.phone = e.target.value;
        }
        if (e.currentTarget.id === 'Email') {
            user.email = e.target.value;
        }
        setNewUser(user);
        forceUpdate();
    };
    const handleOpenAddUser = () => {
        setAddUser(true);
        forceUpdate();
    };
    const handleCloseAddUser = () => {
        setAddUser(false);
        forceUpdate();
    };
    const handleUserMenu = () => {
        setUserMenu(true);
        forceUpdate();
    };
    const handleCloseUserMenu = () => {
        setUserMenu(false);
        forceUpdate();
    };
    const handleRoleChange = (e) => {
        let user = NewUser;
        user.roles = [e.target.value === 'Admin' || e.target.value === 'Fulfillment' ? 1987 : e.target.value === 'Client' ? 1989 : 1988];
        user.permissions = [];
        if (user.roles[0] === 1987) {
            user.permissions.push(
                'User_Create', 'User_View', 'User_Update', 'User_Get',
                'Client_Create', 'Client_View', 'Client_Update', 'Client_Get',
                'Professional_Create', 'Professional_View', 'Professional_Update', 'Professional_Get',
                'Brief_Create', 'Brief_View', 'Brief_Update', 'Brief_Get',
            )
        };
        if (user.roles[0] === 1989) {
            user.permissions.push(
                'Client_Create', 'Client_View', 'Client_Update', 'Client_Get',
                'Professional_View', 'Professional_Get',
                'Brief_Create', 'Brief_View', 'Brief_Update', 'Brief_Get',
            )
        };

        if (user.roles[0] === 1988) {
            user.permissions.push(
                'Client_View', 'Client_Get',
                'Professional_Create', 'Professional_View', 'Professional_Update', 'Professional_Get',
                'Brief_Create', 'Brief_View', 'Brief_Update', 'Brief_Get',
            )
        };
        // if (user.roles[0] === 'Super Admin') {
        //     user.permissions.push(
        //         'User_Create', 'User_View', 'User_Update', 'User_Get',
        //         'Client_Create', 'Client_View', 'Client_Update', 'Client_Get',
        //         'Professional_Create', 'Professional_View', 'Professional_Update', 'Professional_Get',
        //         'Brief_Create', 'Brief_View', 'Brief_Update', 'Brief_Get',
        //         'Override'
        //     )
        // };
        // if (user.roles[0] === 'Fulfillment') {
        //     user.permissions.push(
        //         'Client_View', 'Client_Get',
        //         'Professional_View', 'Professional_Get',
        //         'Brief_View', 'Brief_Update', 'Brief_Get',
        //     )
        // };
        // if (user.roles[0] === 'Talent Partner') {
        //     user.permissions.push(
        //         'User_View', 'User_Get',
        //         'Client_View', 'Client_Get',
        //         'Professional_View', 'Professional_Get',
        //         'Brief_View', 'Brief_Update', 'Brief_Get',
        //     )
        // };

        // if (user.roles[0] === 'Senior Talent Partner') {
        //     user.permissions.push(
        //         'Client_View', 'Client_Update', 'Client_Get',
        //         'Professional_View', 'Professional_Update', 'Professional_Get',
        //         'Brief_View', 'Brief_Update', 'Brief_Get',
        //     )
        // };

        setNewUser(user);
        forceUpdate();
    }
    const backClicked = (back, isEdited) => {
        if (isEdited) {
            getUsers();
        };
        setViewUser(back);
        forceUpdate();
    };
    const handleTitleFilterComps = (e) => {
        let users = Users
        let activeSortKey = Sortkey;
        let id = e.target.id;
        if (id === 'SortByTitle') {
            activeSortKey.Title = true;
            activeSortKey.Department = false;
            if (NameFilter === 'Z-A') {
                setNameFilter('A-Z');
                users.sort((a, b) => a.fullName.localeCompare(b.fullName));
            } else {
                setNameFilter('Z-A');
                users.sort((a, b) => b.fullName.localeCompare(a.fullName));
            };
        };
        if (id === 'SortByRole') {
            activeSortKey.Title = false;
            activeSortKey.Department = true;
            if (RoleFilter === 'Z-A') {
                setRoleFilter('A-Z');
                // users.sort((a, b) => a.role.localeCompare(b.role));
            } else {
                setRoleFilter('Z-A');
                // users.sort((a, b) => b.role.localeCompare(a.role));
            };
        };
        if (id === 'SortByDate') {
            activeSortKey.Title = false;
            activeSortKey.Department = true;
            if (DateFilter === 'Z-A') {
                setDateFilter('A-Z');
                users.sort((a, b) => {
                    if (!a.createdAt) return 1;
                    if (!b.createdAt) return -1;
                    return new Date(a.createdAt) - new Date(b.createdAt);
                });
            } else {
                setDateFilter('Z-A');
                users.sort((a, b) => {
                    if (!a.createdAt) return 1;
                    if (!b.createdAt) return -1;
                    return new Date(b.createdAt) - new Date(a.createdAt);
                });
            }
        };

        setSorKey(activeSortKey);
        forceUpdate();
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        forceUpdate();
    };
    const filteredUsers = Users.filter(user => {
        const searchValue = searchTerm.toLowerCase();
        return (String(`${user?.firstName ? user.firstName : user.companyName || ''}`).toLowerCase().includes(searchValue) || (user.email && user.email.toLowerCase().includes(searchValue)));
    });
    const formatDate = (inputDate) => {
        if (inputDate === undefined || !inputDate) {
            return `00/00/0000`
        }
        const date = new Date(inputDate);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    if (mobile()) {
        return (
            <div>
            </div>
        );
    } else {
        return (
            <div className='userPage'>
                <div className='userPageHeader'>
                    <p style={{ margin: '0px' }}>Users</p>
                    <img src={Credipple} alt='Credipple Logo' />
                </div>
                <div className='userPageBody'>
                    {(ViewProject) ?
                        <ViewProjectPage className='ViewProject-Container' /> :
                        (ViewUser) ?
                            <ViewUserPage backClick={(e, isEdited) => { backClicked(e, isEdited) }} selectedPro={SelectedUser} leads={Leads} pros={Professionals} />
                            :
                            <div className='usersList'>
                                <div className='userListHeader'>
                                    <div className='userListSection'>
                                        <p style={{ margin: '0px' }}>User list</p>
                                        {store.user.permissions.includes("User_Create") ? (<div className='openAddUser' onMouseEnter={handleUserMenu} onMouseLeave={handleCloseUserMenu}>...
                                            {(UserMenu) ?
                                                <div className='userMenuOpen'>
                                                    <div className='AddUserConatiner'>
                                                        <img src={AddIcon} alt='Add User' onClick={handleOpenAddUser} />
                                                        <p onClick={handleOpenAddUser}>Add User</p>
                                                    </div>
                                                    <hr />
                                                </div> : null}
                                        </div>) : null}
                                    </div>
                                    <div className='numofItems'>
                                        <p className='spancular'>{filteredUsers.length}</p>
                                    </div>
                                    <div className='search-bar-section' style={{ width: '25%', height: '60%' }}>
                                        <img src={SearchIcon} alt='Search Icon' />
                                        <input style={{ color: '#6D4194' }} placeholder='Search' value={searchTerm} onChange={handleSearchChange}></input>
                                    </div>
                                </div>
                                <div className='userListContent'>
                                    <div className='userListLabels'>
                                        <div className='userRoleSect'>
                                            <p style={{ margin: '0px', cursor: 'pointer' }} id='SortByTitle' onClick={handleTitleFilterComps}>User Name</p>
                                            <img src={NameFilter === 'A-Z' ? AtoZ : ZtoA} id='SortByTitle' style={{ cursor: 'pointer' }} onClick={handleTitleFilterComps} />
                                        </div>
                                        <div className='userRoleSect'>
                                            <p style={{ margin: '0px', cursor: 'pointer' }} id='SortByRole' onClick={handleTitleFilterComps}>User Role</p>
                                            {/* <img src={RoleFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='SortByRole' onClick={handleTitleFilterComps} /> */}
                                        </div>
                                        <div className='userDetails'>
                                            <p style={{ margin: '0px' }}>User Details</p>
                                        </div>
                                        <div className='dateCreatedsect'>
                                            <p style={{ margin: '0px', cursor: 'pointer' }} id='SortByDate' onClick={handleTitleFilterComps}>Date Created</p>
                                            <img src={DateFilter === 'A-Z' ? AtoZ : ZtoA} style={{ cursor: 'pointer' }} id='SortByDate' onClick={handleTitleFilterComps} />
                                        </div>
                                    </div>
                                    <div className='availableUsersSection'>
                                        {filteredUsers.map((item, index) => (
                                            <div className='availUsers' key={index}>
                                                <p className='availUserName'>{item.fullName}</p>
                                                <p className='availUserRole'>{Object.keys(item).includes('roles') && Array.isArray(item.roles) ? item.roles[0] === 1987 ? 'Admin' : item.roles[0] === 1988 ? 'Professional' : item.roles[0] === 1989 ? 'Client' : item.roles[0] : 'Not Assigned'}</p>
                                                <p className='availUserViewSec' style={{ margin: '0px' }} onClick={() => handleViewUser(item._id)}>View</p>
                                                <p style={{ margin: '0px', color: '#AFAFAF' }}>{formatDate(item.createdAt) || '00/00/0000'}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>}
                </div>
                {(AddUser) ?
                    <div className='dashPopUp'>
                        <div className='addUserHeaderSection'>
                            <p>Create User</p>
                        </div>
                        <div className='addUserBodySection'>
                            <div className='topInputs'>
                                <TextInput className='userInfoFields' placeholder='Name & Surname' label='Name & Surname' id='Name' onChange={handleUserDetailChange}></TextInput>
                                <TextInput className='userInfoFields' placeholder='Contact Number' label='Contact Number' id='ContactNumber' onChange={handleUserDetailChange}></TextInput>
                            </div>
                            <div className='topInputs'>
                                <TextInput className='userInfoFields' placeholder='Email' label='Email' id='Email' onChange={handleUserDetailChange}></TextInput>
                                <TextInputDropdown className='userInfoFields' placeholder='Role' label='Role' id='Role' onChange={handleRoleChange}>
                                    {/* <MenuItem value='SuperAdmin'>Super Admin</MenuItem> */}
                                    <MenuItem value='Admin'>Admin</MenuItem>
                                    <MenuItem value='Client'>Client</MenuItem>
                                    <MenuItem value='Professional'>Professional</MenuItem>
                                    <MenuItem value='Fulfillment'>Fulfillment</MenuItem>
                                    {/* <MenuItem value='TalentPartner'>Talent Partner</MenuItem> */}
                                    {/* <MenuItem value='SeniorTalentPartner'>Senior Talent Partner</MenuItem> */}
                                </TextInputDropdown>
                            </div>
                        </div>
                        <div className='addUserActionSection'>
                            <OutlinedButton className='cancelButton' onClick={handleCloseAddUser}>Cancel</OutlinedButton>
                            <OutlinedButton className='saveButton' onClick={handleSaveUser}>Save</OutlinedButton>
                        </div>
                    </div> : null}
            </div>
        )
    }
})

export default Users;